import { SearchBox, Stack, TextField, TooltipHost } from "@fluentui/react";
import React, { useRef, useEffect, useContext, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import {
  downloadPdfReport,
  getAllPathologies,
} from "../../../../service/StudyReportService";
import { DefaultPalette } from "@fluentui/react/lib/Styling";
import MicIcon from "../../../../components/SVGComponents/MicIcon";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import { historyDownload } from "../../../../service/StudyViewerService";
import DownloadIcon from "../../../../components/SVGComponents/DownloadIcon";
import Download from "../../../../components/SVGComponents/Tools/Download";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import { t } from "i18next";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";

const AttachmentBox = (props) => {
  const ref = useRef(null);
  const { onClickOutside } = props;

  const {
    allAnnotations,
    addOrRemoveAnnotation,
    searchInputValue,
    setSearchInputValue,
    addStudyAnnotation,
  } = useContext(AnnotationContext);
  const { studyHistoryData, studyParentId ,studyClinicalNotesData} = useContext(studyviewerContext);
  const { getAlterColor } = useContext(themeContext);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const printPreviewHistoryDoc = async (historyDoc) => {
    let n = historyDoc.indexOf("/");
    let result = historyDoc.substring(n + 1);
    let extension = getFileExtension(getFileName(result));
    let body = {
      studyId: studyParentId,
      filePath: result,
    };
    try{
        let res = await historyDownload(body,extension);
    }catch(e){

    }
    
  };

  // program to get the file extension

function getFileExtension(filename){

  // get file extension
  const extension = filename.split('.').pop();
  return extension;
}

  const getFileName = (str) => {
    let s = str.lastIndexOf("/");
    if(s != -1){
        return str.substring(s+1);
    }
    return "";
  }

  const showPopUp = () =>{
    if(props.boxName == "history"){
      if(props.setShowAttachment != null && props.setShowAttachment != undefined){
        props.setShowAttachment(true);
      }
    }else{
      if(props.setShowClinicalNotes != null && props.setShowClinicalNotes != undefined){
        props.setShowClinicalNotes(true);
      }
    }
    
  }

  const hidePopUp = () =>{
    if(props.boxName == "history"){
      if(props.setShowAttachment != null && props.setShowAttachment != undefined){
        props.setShowAttachment(false);
      }
    }else{
      if(props.setShowClinicalNotes != null && props.setShowClinicalNotes != undefined){
        props.setShowClinicalNotes(false);
      }
    }
    
  }

  const getContent = (data) => {
    if(data == "history"){
        return (
          <>
          <p style={{color:getAlterColor("#A19F9D","#000")}} className="heading-history-data-options">{t("heading.history-uploaded")}</p>
            <ul className="dropdown-menu-history scrollable-menu modal-scroll">
        {props.studyHistoryData?.length > 0 ? (
          props.studyHistoryData?.map((report, index) => {
            return (
              <li
                key={index}
                onClick={(event) => {
                  printPreviewHistoryDoc(props.studyHistoryData[index]);
                }}
              >
                <div style={{display:'flex'}}>
                <CustomToolTipHost content={`${getFileName(report)}`} id="View Report">
                <span style={{display:'flex',alignItems:'center'}}>
                
                    <a style={{color:getAlterColor("#A19F9D","#000")}} className="report-name-text">{getFileName(report)}</a>
                    
                </span>
                </CustomToolTipHost>
                  <span style={{ display: "flex",alignItems:'center',justifyContent:'center' }}>
                    {getFileExtension(getFileName(report)) == "doc" || 
                    getFileExtension(getFileName(report)) == "docx" ?
                    <Download color={getAlterColor("#C1C1C1","")} />:
                    <EyeIcon color={getAlterColor("#C1C1C1","")} />}
                  </span>
                </div>
              </li>
            );
          })
        ) : (
          <li className="no-result">
            <a>{t("search-message.no-result")}</a>
          </li>
        )}
      </ul></>
        )
    }else if(data == "notes"){
        return (
          <>
          <p className="heading-history-data-options" style={{color: getAlterColor("#A19F9D","")}}>{t("heading.clinical-notes")}</p>
            <div  style={{color: getAlterColor("#c9c7c4","")}} className="clinical-notes-menu scrollable-menu modal-scroll">
            {props.studyClinicalNotesData}
            </div>
          </>
        )
    }
  }

  return (
    <div
      onClick={(ev) => {
        ev.stopPropagation();
      }}
      onMouseEnter={showPopUp} onMouseLeave={hidePopUp}
      ref={ref}
      className={`history-data-options ${props.boxName == "notes"?"left-cls":"no-left-cls"}`}
      // style={{left:props.boxName=="notes"?"-30em":"1em"}}
    >
      {getContent(props.boxName)}
    </div>
  );
};

export default AttachmentBox;
